<template>
    <v-tab-item :value="thisTab" class="fill-height pa-16">
        <v-layout column justify-center class="h-100 mx-auto" style="max-width: 1224px">
            <v-sheet style="flex: 1 1 auto; overflow-x: hidden; overflow-y: auto" class="scroll-primary pr-10">
                <vertical-form-table
                    v-model="form"
                    v-bind="{
                        items,
                        class: 'flex-grow-1',
                    }"
                    @input="emit"
                />
            </v-sheet>
            <div class="v-btn-group flex-wrap my-12">
                <v-btn
                    outlined
                    color="grey-d"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                    }"
                    @click="$emit('prev')"
                >
                    <v-icon color="grey-6">mdi-chevron-left</v-icon>
                    <span class="grey-6--text"> 이전 단계 </span>
                </v-btn>
                <v-btn
                    color="primary"
                    class="min-w-140px min-w-lg-160px"
                    v-bind="{
                        loading,
                        disabled,
                    }"
                    @click="$emit('next')"
                >
                    <span> 첨부 완료 </span>
                    <v-icon style="color:white!important">mdi-chevron-right</v-icon>
                </v-btn>
            </div>
        </v-layout>
    </v-tab-item>
</template>

<script>
import { EMPLOYMENT_FIELD_TYPES, initEmploymentContract } from "@/assets/variables";

import { TABS } from "../lib";

import VerticalFormTable from "@/components/dumb/vertical-form-table.vue";

const thisTab = TABS.FILE.value;

export default {
    components: {
        VerticalFormTable,
    },
    props: {
        /** @type {import('vue').PropType<import('@/assets/variables').EmploymentContract>} */
        value: { type: Object, default: initEmploymentContract },
        tab: { type: String, default: TABS.VIEW.value },
        shows: { type: Boolean, default: false },
        loading: { type: Boolean, default: false },
    },
    data: () => ({
        /** @type {Object<string, import('@/assets/variables').EmploymentField>} */
        form: {},

        thisTab,
    }),
    computed: {
        isOn() {
            return this.shows && this.tab == thisTab;
        },
        items() {
            return Object.keys(this.form).map((key) => ({
                key: `${key}.file`,
                term: this.form[key]?.term,
                type: "file",
                required: this.form[key]?.isRequired,

                outlined: true,
            }));
        },
        disabled() {
            return Object.values(this.form).some((item) => item.isRequired && !item.file);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            /** @type {import('@/assets/variables').EmploymentContract} */
            let { fields_employee } = this.value;

            this.form = fields_employee.reduce((form, item) => {
                if (item.type == EMPLOYMENT_FIELD_TYPES.FILE.value) {
                    form[item.tempId] = item;
                }

                return form;
            }, {});
        },

        emit() {
            /** @type {import('@/assets/variables').EmploymentContract} */
            let { fields_employee } = this.value;

            fields_employee = fields_employee.map((item) => this.form[item.tempId] || item);

            this.$emit("input", { ...this.value, fields_employee });
        },
    },
};
</script>
